<template>
  <div class="modal fade light " id="modalAffiliate" ref="bank" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-background modal-lg">
      <div class="modal-content">
        <div class=" ">
          <header class="modal-card-head">
            <p class="modal-card-title">ชวนเพื่อน</p><button aria-label="close" data-dismiss="modal"
              class="delete"></button>
          </header>
          <section class="modal-card-body">

            <div class="-full-flex-inner-bg -bg">
              <div class="x-promotion-index">
                <div class="container">
                  <div class="">
                    <div class="-inner-content" style="margin-top: 0px;">

                      <hr>
                      <div class="master-wrapper">
                        <div class="">

                          <section class="" id="section-instruction-promotion-return-bet">
                            <div class="form-group row">
                              <label
                                class="col-sm-4 col-form-label col-form-label-sm text-center mt-2">ลิงค์รับทรัพย์ของคุณ</label>
                              <div class="col-sm-8">
                                <div class="form-group">
                                  <div class="input-group mb-2">
                                    <input class="form-control" id="urlAff" name="" placeholder="" type="text"
                                      readonly="" :value="affiliateLink">
                                    <div class="input-group-prepend">
                                      <div class="input-group-text" id="copyUrlAff" @click="copyAF(affiliateLink)"><i
                                          class="far fa-copy"></i></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="card mb-12 border border-gold mt-2">
                              <div class="card-header text-center text-warning"><i class="fas fa-comments-dollar"></i>
                                รายได้</div>
                              <div class="card-body py-4">
                                <div class="row">

                                  <div class="col-12 text-center aff-block-4">
                                    <h6 class="text-black">สมัคร</h6>
                                    <h4 class="text-center no-margins">
                                      <a href="#" id="statistics-member"><span class="text-black">{{
                                        Users.length
                                      }}</span></a>
                                    </h4>
                                  </div>

                                  <div class="col-12 text-center aff-block-4">
                                    <h6 class="text-black">รายได้สะสมของคุณ</h6>
                                    <h4 class="text-center no-margins">
                                      <span class="text-success"> {{ income | formatNumber }}</span>
                                    </h4>
                                    <hr class="my-3">
                                    <div class="text-center">
                                      <button @click="WithdrawAffiliate()" class="button full-50 is-primary">
                                        แจ้งถอนรายได้
                                      </button>
                                    </div>
                                    <!-- <span class="text-danger">หมายเหตุ: ระบบจะทำการตัดยอดให้ทุกวันในช่วงเวลา 03.00</span> -->
                                  </div>
                                </div>
                              </div>
                            </div>


                            รายละเอียด

                            <table role="table" aria-busy="false" aria-colcount="2" class="table b-table table-sm"
                              id="__BVID__851" style="color: #000000">
                              <!----><!---->
                              <thead role="rowgroup" class="">
                                <!---->
                                <tr role="row" class="">
                                  <th role="columnheader" scope="col" aria-colindex="1"
                                    class="small text-left text-color p-1">
                                    <div>วันที่/เวลา</div>
                                  </th>
                                  <th role="columnheader" scope="col" aria-colindex="2"
                                    class="small text-center text-color p-1">
                                    <div>จำนวน</div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody role="rowgroup" v-if="TransIncome.length == 0">
                                <!---->
                                <tr role="row" class="">
                                  <td colspan="2" role="cell" class="">
                                    <div role="alert" aria-live="polite">
                                      <div class="text-center pt-2 fs-14">
                                        ไม่มีข้อมูล
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <!---->
                              </tbody>

                              <tbody role="rowgroup" v-if="TransIncome.length > 0">
                                <!---->
                                <tr v-for="(item, i) in TransIncome" :key="i" role="row">
                                  <td role="cell" class="small text-left text-color p-1">
                                    {{ getDate(item.createdAt) }}
                                  </td>
                                  <td role="cell" class="small text-center text-color p-1">
                                    {{ item.Amount }}
                                  </td>
                                </tr>

                                <!----><!---->
                              </tbody>
                              <!---->
                            </table>



                          </section>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="container mt-3">
                  <div class="row">
                    <div class="col-12 col-md-9 col-lg-6 mx-auto animated fadeInUp" data-animatable="fadeInUp"
                      data-delay="100">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>



</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { UserInfoMixins } from '@/mixins/UserInfo.js'
import { PrefixMixins } from '@/mixins/Prefix.js'
import { BankMixins } from '@/mixins/BankService.js'
import { fetchAffiliate, WithdrawAffiliate } from '@/services/modules/af.js'
import moment from 'moment'

export default {
  name: 'AfForm',
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],

  data() {
    return {
      income: 0,
      Users: [],
      Trans: [],
      TransIncome: [],
      userData: {},
      setting: {},
      affiliateLink: '',
    }
  },
  computed: {
    ...mapGetters([
      'getError',
      'getLoading',
      'getLineId',
      'getGameList',
      'getPromotion',
      'getPrefix',
    ]),
  },
  methods: {
    getDate: function (data) {
      return moment(data).format('DD MMMM YYYY, h:mm:ss a')
    },
    async copyAF(item) {
      this.$copyText(item, this.$refs.af)
      this.$swal.fire('คัดลอกแล้ว', '', 'success')
    },
    async fetchAffiliate() {
      await fetchAffiliate((res) => {
        if (res.status) {
          this.income = res.data.balance
          this.Trans = res.data.transaction
          this.Users = res.data.Users
          this.TransIncome = res.data.transaction_incomes
          this.setting = res.data.setting
        }
      })
    },

    async WithdrawAffiliate() {
      await WithdrawAffiliate((res) => {
        if (res.status) {
          this.$swal.fire('Success!', '', 'success')
        } else {
          this.$swal.fire(res.message, '', 'error')
        }
      })
    },
  },
  async mounted() {
    await this.fetchAffiliate()
    this.affiliateLink = ''
    this.affiliateLink =
      window.location.origin + '/user/register/' + this.UserInfo.affiliateKey
  },
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/form/AfForm.vue